export default __webpack_public_path__ + "static/media/mode-570.82c2b20e.svg";